import { render, staticRenderFns } from "./drawerHeader.vue?vue&type=template&id=4911bdcb"
import script from "./drawerHeader.vue?vue&type=script&lang=js"
export * from "./drawerHeader.vue?vue&type=script&lang=js"
import style0 from "./drawerHeader.vue?vue&type=style&index=0&id=4911bdcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports